/** Small, coherent engraved symbols; labels remain visible beside navigation icons. */
export function GameIcon({
  name,
  size = 22,
}: {
  name: "village" | "map" | "trials" | "reports" | "sound" | "muted";
  size?: number;
}): JSX.Element {
  const paths = {
    village: "M3 9 12 3l9 6H3Zm2 3v7m5-7v7m4-7v7m5-7v7M3 21h18M3 11h18",
    map: "m3 5 6-2 6 2 6-2v16l-6 2-6-2-6 2V5Zm6-2v16m6-14v16",
    trials: "M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9L12 3Z",
    reports: "M7 4h13v13a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3h12a3 3 0 0 0 6 0M7 4v13M10 8h7m-7 4h5",
    sound: "M4 9h4l5-4v14l-5-4H4V9Zm12-1a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14",
    muted: "M4 9h4l5-4v14l-5-4H4V9Zm12 1 5 5m0-5-5 5",
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  );
}
